import React, {PureComponent} from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import moment from 'moment';

class DatePickerField extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            startDate: props.defaultDate
        };
        this.props.onChange(props.defaultDate);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(date) {
        this.setState({
            startDate: date
        });
        this.props.onChange(date);
    }


    render() {
        return (
            <div className='date-picker'>
                <DatePicker
                    className='form__form-group-datepicker'
                    onChange={this.handleChange}
                    filterDate={this.props.filterDate}
                    placeholderText='dd/mm/yyyy'
                    selected={this.props.value ? moment(this.props.value) : null}
                    dateFormat='DD/MM/YYYY'
                />
            </div>
        )
    }
}

const renderDatePickerField = (props) => (
    <div className='form__form-group-input-wrap'>
        <DatePickerField
            {...props.input}
            filterDate={props.filterDate}
            defaultDate={props.defaultDate}
        />
        {props.meta.touched && props.meta.error && <span className='form__form-group-error'>{props.meta.error}</span>}
    </div>
);

renderDatePickerField.propTypes = {
    input: PropTypes.object.isRequired
};

export default renderDatePickerField;


// WEBPACK FOOTER //
// ./src/theme/components/form/DatePicker.js